import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import styled from "styled-components";
import data from "../data/rushdata.json";

const IndustriesCard = () => {
  return (
    <Wrapper style={{ transform: "translateY(-300px)" }}>
      <Container>
        <Row className="industires__card__wrap">
          {data.industries.map(({ id, icon, indutrieshead, industriesP }) => (
            <Col sm={12} md={4}>
              <Card
                style={{ width: "18rem" }}
                key={id}
                className="industries__main"
              >
                <Card.Img variant="top" src={icon} />
                <Card.Body>
                  <Card.Title>{indutrieshead}</Card.Title>
                  <Card.Text>{industriesP}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
          {data.industriesImage.map(
            ({ id, indusPrice, indusPriDes, image }) => (
              <Row className="indus__row">
                <Col sm={12} md={6}>
                  <div className="industries__img__Wrapper" key={id}>
                    <img className="industries__img" src={image} alt="Images" />
                  </div>
                </Col>
                <Col sm={12} md={6}>
                  <div className="industries__des">
                    <h1>{indusPrice}</h1>
                    <p>{indusPriDes}</p>
                  </div>
                </Col>
              </Row>
            )
          )}
        </Row>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  @media screen and (max-width: 440px) {
    transform: translateY(-236px) !important;
    .industries__img__Wrapper {
      width: 100% !important;
      height: auto;
      .industries__img {
        width: 100% !important;
        height: auto !important;
        object-fit: cover !important;
        padding: 20px;
        margin-top: 122px !important;
        margin-bottom: 160px !important;
      }
    }
    .indus__row.row {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-align-items: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      margin-top: 120px;
      margin-bottom: -380px;
      flex-direction: column-reverse;
    }

    .industries__des {
      width: 100% !important;
      padding: 20px;
      transform: translateX(0px) !important;
      h1 {
        font-family: Gilroy-Heavy !important;
        font-size: 32px !important;
        line-height: 46px !important;
        color: #6300ff;
        width: 100% !important;
        height: 100% !important;

        color: #6300ff !important;
      }
      p {
        font-family: Manrope !important;
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        line-height: 28px !important;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        color: #545777;
        width: 100% !important;
        margin-top: 20px !important;
      }
    }
    .industires__card__wrap {
      margin-top: 70px;
    }
  }
  @media screen and (max-width: 768px) {
    .industries__main {
      background: #ffffff;
      box-shadow: 0px 4px 40px rgba(227, 243, 255, 0.68);
      border-radius: 14px;
      margin-bottom: -60px;
      width: 100% !important;
      height: 360px;
      margin-top: 100px;

      border: none;
      .card-body {
        padding: 0 20px;
        p.card-text {
          font-family: Manrope;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 18px;
          margin-top: 20px;
          color: #545777;
          -webkit-letter-spacing: 0.8px;
          -moz-letter-spacing: 0.8px;
          -ms-letter-spacing: 0.8px;
          letter-spacing: 0.8px;
          width: 100% !important;
        }
      }
    }
    .industries__des {
      width: 100% !important;
      padding: 20px;
      transform: translateX(0px) !important;
      h1 {
        font-family: Gilroy-Heavy;
        font-size: 36px;
        line-height: 46px;
        color: #6300ff;
        width: 100% !important;
        height: 100% !important;
      }
      p {
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        color: #545777;
        width: 100% !important;
      }
    }
  }
  .industries__main {
    background: #ffffff;
    box-shadow: 0px 4px 40px rgba(227, 243, 255, 0.68);
    border-radius: 14px;
    margin-bottom: 30px;
    width: 330px !important;
    height: 360px;
    margin: 15px auto;
    border: none;
    img {
      width: 56px;
      height: 56px;
      margin-top: 50px;
      margin-left: 26px;
    }
  }

  .card-title.h5 {
    font-family: Gilroy-Heavy;
    font-size: 24px;
    line-height: 26px;
    color: #6300ff;
    margin-top: 25px;
  }
  p.card-text {
    font-family: Manrope;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    margin-top: 20px;
    color: #545777;
    letter-spacing: 0.8px;
    width: 290px;
  }
  .card-body {
    margin: 0 13px;
  }
  .industries__img__Wrapper {
    width: 100% !important;
    height: auto;
    .industries__img {
      width: 100% !important;
      height: auto;
      object-fit: cover;
      padding: 20px;
    }
  }

  .industries__des {
    transform: translateX(110px);

    h1 {
      font-family: Gilroy-Heavy;
      font-size: 36px;
      line-height: 46px;
      color: #6300ff;
      width: 480px;
      height: 100px;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      display: flex;
      align-items: center;
      color: #545777;
      width: 450px;
    }
  }
  .indus__row.row {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 120px;
    margin-bottom: -380px;
  }
`;

export default IndustriesCard;
